
import { getUrl } from "@insite/client-framework/ServerSideRendering";
import PageProps from "@insite/client-framework/Types/PageProps";


const prepareArticleStructuredPageData = (languageKey:string,page?: PageProps,website?:any) => {
    if (!page) {
        return "";
    }
    const url: { protocol: string; host: string } = IS_SERVER_SIDE ? getUrl()! : window.location;
    const authority = `${url.protocol}//${url.host}`;

    const dateString = page.fields["publishDate"];
  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
  const day = String(date.getDate()).padStart(2, '0');

        const data = {
            "@context": "https://schema.org",
            "@type": "Article",
            "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": authority + "/news"+ "/"+ page.translatableFields["urlSegment"][languageKey]
            },
            "headline": page.translatableFields["title"] ? page.translatableFields["title"][languageKey] : "",
            "image": [""],
            "datePublished": `${year}-${month}-${day}`,
           
            "dateModified": "",
            "author": {
                "@type": "Person",
                 "name": page.fields["author"]
            },
            "publisher": {
                "@type": "Organization",
                "name": "DSG",
                "logo": {
                    "@type": "ImageObject",
                    "url":  website.companyLogoImagePath &&
                    (website.companyLogoImagePath.indexOf("http") === 0
                        ? website.companyLogoImagePath
                        : authority + website.companyLogoImagePath)
                }
            },
            "description": page.translatableFields["title"] ? page.translatableFields["title"][languageKey] : ""
          
        } as any; 
       
    
    
   
    return JSON.stringify(data);
};

export default prepareArticleStructuredPageData;
